var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 666,
    height: 625,
    viewBox: "0 0 666 625",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M635.93 418.96H540.13C540.13 418.78 540.18 418.61 540.18 418.42V115.09C540.18 51.53 488.65 0 425.09 0H292.97V124.54L200.73 0H0V418.42C0 418.59 0.05 418.75 0.05 418.93V477.7C0.05 558.8 65.79 624.55 146.9 624.55H518.46C599.56 624.55 665.3 558.81 665.3 477.71V448.34C665.3 432.11 652.15 418.96 635.93 418.96ZM235 448.33V474.78C235 523.29 197.05 564.91 148.54 565.79C99.12 566.69 58.78 526.91 58.78 477.7V419.17C58.79 418.91 58.86 418.68 58.86 418.42V382.85H327.9C340.36 382.85 351.54 373.52 352.19 361.07C352.89 347.79 342.33 336.81 329.2 336.81H58.86V287.42H220.9C231.89 287.42 241.86 279.97 244.04 269.2C247.03 254.39 235.79 241.38 221.51 241.38H58.86V58.86H171.08L294.61 225.66C304.11 238.46 321.8 242.48 336.26 234.08C346.21 228.3 351.83 217.17 351.83 205.67V58.86H410.52C449.62 58.86 481.31 90.55 481.31 129.65V418.41C481.31 418.59 481.36 418.76 481.36 418.95H264.36C248.15 418.96 235 432.11 235 448.33ZM518.45 565.8H263.64C283.07 540.53 293.65 509.57 293.75 477.69H606.57C606.56 526.36 567.11 565.8 518.45 565.8Z",
    fill: "#DD7300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.2d2c31492c300cf94c0825366c60d1ed.svg";
export { ForwardRef as ReactComponent };